import MuiTooltip, { TooltipProps as MuiTooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';

export interface TooltipProps extends MuiTooltipProps {
	/** Controls the max-width of the tooltip popover. */
	size?: 'small' | 'medium' | 'large';
}

const tooltipMaxWidth: Record<NonNullable<TooltipProps['size']>, string> = {
	small: '12rem',
	medium: '20rem',
	large: 'unset'
};

/** Styled Tooltip */
const StyledTooltip = styled(({ className, size, ...props }: TooltipProps) => <MuiTooltip {...props} classes={{ popper: className }} />)(
	({ theme, size }) => ({
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: theme.palette.swiftfox.blue['60-midnight'],
			...(size !== undefined ? { maxWidth: tooltipMaxWidth[size] } : {})
		},
		[`& .${tooltipClasses.arrow}`]: {
			color: theme.palette.swiftfox.blue['60-midnight']
		}
	})
);

/**
 * A tooltip is a simple title or description that appears when hovering over an element.
 * For anything more complex than a short string of text, our Popover component should be used.
 */
export const Tooltip = (props: TooltipProps) => {
	const { children, ...rest } = props;

	return (
		<StyledTooltip arrow={props.arrow ?? true} {...rest}>
			{children}
		</StyledTooltip>
	);
};
